import { axios, API } from './config';

export const posMenuAPI = {
  // Categories
  listCategories: async () => (await axios.get(`${API}/pos/menu/categories`)).data,
  createCategory: async (payload) => (await axios.post(`${API}/pos/menu/categories`, payload)).data,
  updateCategory: async (id, payload) => (await axios.put(`${API}/pos/menu/categories/${id}`, payload)).data,
  deleteCategory: async (id) => (await axios.delete(`${API}/pos/menu/categories/${id}`)).data,

  // Drinks
  listDrinks: async () => (await axios.get(`${API}/pos/menu/drinks`)).data,
  createDrink: async (payload) => (await axios.post(`${API}/pos/menu/drinks`, payload)).data,
  updateDrink: async (id, payload) => (await axios.put(`${API}/pos/menu/drinks/${id}`, payload)).data,
  deleteDrink: async (id) => (await axios.delete(`${API}/pos/menu/drinks/${id}`)).data,
};
